module.exports = __webpack_public_path__ + "img/search.70d7efe5.svg";